import { ChatRole } from '../../types/ChatRoles';
import { ChatBlockType, ChatMessageType, ClientConversation, ClientMessage } from './types';

export const userChatToMessage = (
  text: string,
  conversation: ClientConversation | null,
): ClientMessage => {
  return {
    timestamp: new Date().toISOString(),
    role: ChatRole.User,
    type: ChatMessageType.Chat,
    sequence: conversation?.messages.length || 0,
    blocks: [
      {
        sequence: 0,
        type: ChatBlockType.Text,
        content: text,
        sources: [],
      },
    ],
    sources: [],
  };
};
